import { Globe2, Users, CalendarCheck, Rocket, Sparkles } from "lucide-react";
import { Reveal } from "@/components/Chapter";
import { useContent } from "@/content";

const ICONS = { Globe2, Users, CalendarCheck, Rocket };

export const TrustRow = () => {
  const { TRUST_ROW } = useContent();
  return (
  <section className="max-w-7xl mx-auto px-4 sm:px-8 py-16 md:py-20" data-testid="trust-row-section">
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-slate-200 rounded-2xl overflow-hidden border border-slate-200 shadow-sm">
      {TRUST_ROW.map((t, i) => {
        const Icon = ICONS[t.icon] || Sparkles;
        return (
          <Reveal key={t.title} delay={i * 0.08} className="bg-white">
            <div className="group h-full p-7 hover:bg-slate-50 transition-colors duration-500" data-testid={`trust-item-${i}`}>
              <Icon className="h-5 w-5 text-amber-500 mb-4 transition-transform duration-500 group-hover:scale-125 group-hover:-rotate-6" />
              <h3 className="text-base font-semibold text-[#0B1528] mb-2">{t.title}</h3>
              <p className="text-sm text-slate-500 leading-relaxed">{t.desc}</p>
            </div>
          </Reveal>
        );
      })}
    </div>
  </section>
);
};
